import { Box, Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import { InputMask, InputText, Modal } from "src/components";

function ModalExtrato({ open, close, data }) {
  const handlePrint = (elementId, uniqueIframeId) => {
    const content = document.getElementById(elementId);
    const iframe = document.createElement("iframe");
    iframe.setAttribute("title", uniqueIframeId);
    iframe.setAttribute("id", uniqueIframeId);
    iframe.setAttribute(
      "style",
      "height: 0px; width: 0px; position: absolute;"
    );
    document.body.appendChild(iframe);
    const pri = iframe.contentWindow;

    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  };

  const getDadosVenda = (posicao) => {
    // Posição, caso
    // 0 valor da venda
    // 1 chave da venda

    if (!data.numero_venda) return;

    const splitedData = data.numero_venda
      .split("::")
      .map((item) => item.trim());

    if (
      (!splitedData[1] && posicao === 1) ||
      (!splitedData[0] && posicao === 0)
    ) {
      return null;
    }

    return splitedData[posicao];
  };

  return (
    <Modal open={open} width={520} height="60vh">
      <Box id="iframe" display="flex" flexDirection="column" height="95%">
        <Typography style={{ marginBottom: "8px" }} variant="h3" align="center">
          Comprovante
        </Typography>
        <Box display="flex">
          <Typography> CPF: </Typography>
          <Typography style={{ marginLeft: "4px" }}>
            {data.cliente_cpf}
          </Typography>
        </Box>
        <Box display="flex">
          <Typography> Nome: </Typography>
          <Typography style={{ marginLeft: "4px" }}>
            {data.cliente_nome}
          </Typography>
        </Box>
        {getDadosVenda(0) && (
          <Box display="flex">
            {console.log(getDadosVenda(1))}
            <Typography> Valor da transação: </Typography>
            <Typography style={{ marginLeft: "4px" }}>
              {getDadosVenda(0)}
            </Typography>
          </Box>
        )}
        {data.valor !== 0 && (
          <Box display="flex" alignItems="center">
            <Typography> Cashback: </Typography>
            <InputMask
              style={{ marginLeft: "4px" }}
              type="cash"
              displayType="text"
              value={data.valor}
            />
          </Box>
        )}
        {getDadosVenda(1) && (
          <Box display="flex">
            <Typography> Chave da transação: </Typography>
            <Typography style={{ marginLeft: "4px" }}>
              {getDadosVenda(1)}
            </Typography>
          </Box>
        )}
      </Box>
      <Box display="flex" marginTop="auto" justifyContent="flex-end">
        <Button onClick={() => close({ extrato: false })}>Fechar</Button>
        <Button onClick={() => handlePrint("iframe")}>Imprimir</Button>
      </Box>
    </Modal>
  );
}

export default ModalExtrato;
